import { useQuery } from '@tanstack/react-query'
import API from '../../../utils/api'

// {
//   "cashoutAccounts": [
//       {
//           "id": 10978,
//           "user_id": 184478,
//           "name": "BBVA BANCOMER - 6782",
//           "holder_name": "JUAN GERARDO",
//           "holder_last_name": "GALLEGOS SANCHEZ",
//           "type": "spei",
//           "valid": false,
//           "rejected": false,
//           "documents_count": 1,
//           "created": "2026-04-21T01:17:09+00:00",
//           "modified": "2026-04-21T01:17:09+00:00"
//       }
//   ],
//   "lastPurchase": {
//       "payment_method": "card",
//       "status": "completed",
//       "gateway": "kushki",
//       "bank": "bbva",
//       "account": "6653",
//       "type": "credit",
//       "created": "2026-03-03 20:06:03"
//   }
// }
export const useCashoutAccounts = () => {
  const { data, isLoading, refetch } = useQuery(['/cashout-accounts'], API.getCashoutAccounts)

  return {
    data: data?.data ? {
      ...data?.data,
      defaultCashoutAccountId: getDefaultCashoutAccountId(data?.data),
    } : {},
    isLoading,
    refetch
  }
}


// Utilidad para obtener la cuenta por defecto
const getDefaultCashoutAccountId = (data) => {
  const { cashoutAccounts, lastPurchase } = data

  if (!cashoutAccounts || cashoutAccounts?.length === 0) return null


  // Si tiene almenos una cuenta tratar de obtener la ultima donde hizo el deposito
  if (lastPurchase?.account) {

    const account = cashoutAccounts.find(account => account.name.toLowerCase().includes(lastPurchase.account.toLowerCase()))

    if (account) {
      return account.id
    }
  }

  // Si no coincide ninguna marcar la primera como seleccionada, puede pasar si
  // el lastPurchase fue con credito y posteriormente ya dio de alta una cuenta
  if (cashoutAccounts?.[0]) {
    return cashoutAccounts[0].id
  }

  return null
}
